import * as React from 'react';
import './LedgerFile.scss';

export type LedgerFileProps = {
  /** The file's own name; absent on a row that is not a file. */
  name?: string;
};

/**
 * The File column: a file's own name, cut short with the whole of it on hover.
 * Empty on a row that is not a file. The host turns the column on (see
 * ../../ledger/_columns.scss).
 */
export const LedgerFile: React.FC<LedgerFileProps> = ({ name }) => (
  <span className="tree-ledger-cell tree-ledger-cell--file tree-ledger-file">
    {/* Isolated, so a Latin name on a right-to-left page keeps its order. */}
    {name && <bdi title={name}>{name}</bdi>}
  </span>
);
